import { render } from "./ResultsMobilenew.vue?vue&type=template&id=275eb99e&scoped=true"
import script from "./ResultsMobilenew.vue?vue&type=script&lang=js"
export * from "./ResultsMobilenew.vue?vue&type=script&lang=js"

import "./ResultsMobilenew.vue?vue&type=style&index=0&id=275eb99e&lang=scss"
import "./ResultsMobilenew.vue?vue&type=style&index=1&id=275eb99e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2524174443/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275eb99e"]])

export default __exports__